import axios from 'axios';
// import { useRouter } from 'vue-router';
import { Message } from '@arco-design/web-vue';
// import router from '@/router'; // 导入路由实例

// const router = useRouter();
const ErrorCode = {
  notLogin: 10001,
};

const axiosIns = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// 请求拦截器，内部根据返回值，重新组装，统一管理。
axiosIns.interceptors.response.use((res) => {
  if (!res || typeof res.data !== 'object') {
    Message.error('服务异常,请重试');
    return Promise.reject(res);
  }
  const data = res.data || {};
  const errCode = data.errNo;
  const message = data.errMsg;
  if (+errCode !== 0) {
    if (message) Message.error(message);
    if (errCode === ErrorCode.notLogin) {
      // 使用路由跳转，而非 window.location
      // router.replace({
      //   path: '/login',
      //   query: {
      //   }
      // });
    }
    return Promise.reject(res.data);
  }
  return data;
});

axiosIns.interceptors.request.use((config) => {
  if (config.method === 'get') {
    config.params = { ...config.params };
  }
  if (config.method === 'post') {
    if (config.headers) {
      config.headers['Content-Type'] = 'application/json';
    }
    if (config.data) {
      config.data = { ...config.data };
    }
  } else {
    // 如果是 POST 或其他请求方法，将参数添加到 data
    config.data = { ...config.data };
  }
  // const useOtherLanguage = config.data?.useOtherLanguage || config.params?.useOtherLanguage
  // const languageSession = getLanguage()
  // const lang = useOtherLanguage || languageSession
  // console.log(config.url,'语言参数', lang)
  // config.headers['X-Fx-Lang'] = lang
  return config;
});

const axiosGet = axiosIns.get;
axiosIns.get = (url, data, options = {}) => {
  return axiosGet(url, {
    params: data,
    ...options,
  });
};
export default axiosIns;
